module.exports = __webpack_public_path__ + "img/2-4.93edb853.svg";